import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "./index";
import dateTimeFormats from "./dateTimeFormats";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: navigator.language ? navigator.language.split("-")[0] : "es",
  fallbackLocale: "es",
  messages,
  dateTimeFormats
});

export default i18n;
